import DataLayer from './../lib/dataLayer';
import {append, insertBefore} from './scripts/utilities';

export default class {

  constructor( adObject, tcData, plugins = [] ) {
    this.devMode = 0;
    this.adLibVersion = '1.07.02.01';
    this.getLog( 'adLibVersion: ' + this.adLibVersion );
    this.getLog( 'clientConfig: ' + adObject.configVersion );

    window.googletag = window.googletag || {cmd: []};
    this.gptLibURL = [ 'https://securepubads.g.doubleclick.net/tag/js/gpt.js', 'https://pagead2.googlesyndication.com/tag/js/gpt.js' ];

    window.pbjs = window.pbjs || {};
    window.pbjs.que = window.pbjs.que || [];

    this.ads = window.ads || true;
    this.adObject = adObject;
    this.adQueue = window.adQueue || [];
    this.adZone = window.adZone || '_default';
    this.adSlots = [];
    this.myAdKeywords = window.adKeywords || [];
    this.uri = window.location.pathname;
    this.tcfData = tcData;
    this.cookiesDisable = 0;
    this.nonPersonalizedAds = 0;
    this.ltdAdsEnabled = 0;
    this.blacklist = 0;
    this.plugins = this.registerPlugins( plugins );
    this.integration = false;
    this.pbSlotIncubator = false;
    this.loadScript = [];
    this.bidder = [];
    this.bidder.definedAdSlots = [];
    this.bidder.refreshedAdSlots = [];
    this.bidder.biddingAdSlots = [];
    this.bidder.allBidsBack = false;
    this.bidder.bidTimeoutBuffer = false;
    this.bidTimeout = this.adObject.bidTimeout;
    this.failTimeout = this.bidTimeout + 250;

    this.mobile_375 = 0;
    this.mobile_700 = 0;
    this.tablet_701 = 0;
    this.tablet_1199 = 0;
    this.skyscraper_1200 = 0;
    this.fireplace_1320 = 0;
    this.sitebar_1460 = 0;
    this.contentChannel = this.myAdKeywords.includes('content_channel') || false;

    if ( this.devMode === 1 ) {
      this.getLog( ' DEV MODE ', 'red' );
      this.myAdKeywords.push( 'adtest' );
      this.myAdKeywords.push( 'no_ba' );
      this.myAdKeywords.push( 'no_google' );
    }

    this.getAdTest();
    this.blacklist = this.getBlacklist( this.uri, this.adObject );
    this.getLog( ' blacklist ' + this.blacklist + ' ', 'green' );

    const dataLayer = new DataLayer( window.dataLayer || [] );
    this.bart = dataLayer.getKey( 'bart' );
    this.pageAttributes = dataLayer.getKey( 'pageAttributes' );
    this.pageCategory = dataLayer.getKey( 'pageCategory' );
    this.pageCuisine = dataLayer.getKey( 'pageCuisine' );
    this.pagePostID = dataLayer.getKey( 'pagePostID' );
    this.pagePostType = dataLayer.getKey( 'pagePostType' );
    this.pageType = dataLayer.getKey( 'pageType' );
    this.cmpData = dataLayer.getKey( 'cmp_data' );
    this.tcfData = this.cmpData;

    if ( this.bart !== '' && this.bart !== null) { this.myAdKeywords.push( this.bart ); }
    if ( this.pageCategory !== '' && this.pageCategory !== null) { this.myAdKeywords.push( this.pageCategory ); }
    if ( this.pageCuisine !== '' && this.pageCuisine !== null) { this.myAdKeywords.push( this.pageCuisine ); }
    if ( this.pagePostID !== '' && this.pagePostID !== null) { this.myAdKeywords.push( this.pagePostID ); }
    if ( this.pagePostType !== '' && this.pagePostType !== null) { this.myAdKeywords.push( this.pagePostType ); }
    if ( this.pageAttributes !== '' && this.pageAttributes !== null) {
      this.pageAttributes.forEach(( tag ) => {
        this.myAdKeywords.push( tag );
      });
    }

    if ( this.bart === 'homepage') {
      this.adZone = 'homepage';
    }

    if ( this.adObject.cmp[0].tcfStatus === 1 && this.blacklist < 2 && this.ads === true ) {
      // this.getCookieString();

      if ( this.tcfData.purpose.consents[1] ) {
        if ( this.tcfData.purpose.consents[2] && this.tcfData.purpose.consents[3] && this.tcfData.purpose.consents[4] && this.tcfData.purpose.consents[5] && this.tcfData.purpose.consents[6] && this.tcfData.purpose.consents[7] && this.tcfData.purpose.consents[8] && this.tcfData.purpose.consents[9] && this.tcfData.purpose.consents[10] ) {
          // personalized_ads
          this.nonPersonalizedAds = 0;
          this.myAdKeywords.push( 'personalized_ads' );
          this.getLog( ' personalized_ads 1', 'green' );
        } else {
          // non_personalized_ads
          this.nonPersonalizedAds = 1;
          this.myAdKeywords.push( 'non_personalized_ads' );
          this.getLog( ' non_personalized_ads: 1 = ' + this.nonPersonalizedAds + ' ', 'red' );
        }
      } else {
        this.cookiesDisable = 1;
        this.ltdAdsEnabled = 1;
        this.myAdKeywords.push( 'cookies_disable' );
        this.myAdKeywords.push( 'limited_ads' );
        this.getLog( ' cookiesDisable: ' + this.cookiesDisable + ' ', 'red' );
        this.getLog( ' Limited Ads: ' + this.ltdAdsEnabled + ' ', 'red' );
      }
    }

    if ( this.adObject.mediaSize === 1 ) {
      this.mobile_375 = window.matchMedia( '(min-width: 375px)' ).matches;
      this.mobile_700 = window.matchMedia( '(max-width: 700px)' ).matches;
      this.tablet_701 = window.matchMedia( '(min-width: 701px)' ).matches;
      this.tablet_1199 = window.matchMedia( '(max-width: 1199px)' ).matches;
      this.skyscraper_1200 = window.matchMedia( '(min-width: 1200px)' ).matches;
      this.fireplace_1320 = window.matchMedia( '(min-width: 1320px)' ).matches;
      this.sitebar_1460 = window.matchMedia( '(min-width: 1460px)' ).matches;

      if ( this.mobile_375 && this.mobile_700 ) {
        this.getLog( ' mediaSize mobile_375 ', 'seagreen' );
        this.mobile_375 = 1;
        this.myAdKeywords.push( 'mobile_375' );
      }
      if ( this.mobile_700 ) {
        this.getLog( ' mediaSize mobile_700 ', 'seagreen' );
        this.mobile_700 = 1;
        this.myAdKeywords.push( 'mobile_700' );
      }
      if ( this.tablet_701 && this.tablet_1199 ) {
        this.getLog( ' mediaSize tablet_701 ', 'seagreen' );
        this.tablet_701 = 1;
        this.myAdKeywords.push( 'tablet_701' );
      }
      if ( this.tablet_1199 ) {
        this.getLog( ' mediaSize tablet_1199 ', 'seagreen' );
        this.tablet_1199 = 1;
        this.myAdKeywords.push( 'tablet_1199' );
      }
      if ( this.skyscraper_1200 ) {
        this.getLog( ' mediaSize skyscraper_1200 ', 'seagreen' );
        this.skyscraper_1200 = 1;
        this.myAdKeywords.push( 'skyscraper_1200' );
      }
      if ( this.fireplace_1320 ) {
        this.getLog( ' mediaSize fireplace_1320 ', 'seagreen' );
        this.fireplace_1320 = 1;
        this.myAdKeywords.push( 'fireplace_1320' );
      }
      if ( this.sitebar_1460 ) {
        this.getLog( ' mediaSize sitebar_1460 ', 'seagreen' );
        this.sitebar_1460 = 1;
        this.myAdKeywords.push( 'sitebar_1460' );
      }
    }

    this.getLog('Content-Channel: ' + this.contentChannel);

    this.getLog( adObject );

    this.adQueue = window.adQueue || [];

    this.getLog( this.adQueue );
    this.eventify( this.adQueue, ( updatedArr ) => {
      if ( typeof this.adLogic !== 'undefined' ) {
        for ( let i = 0; i < updatedArr.length; i++ ) {
          this.adLogic( updatedArr[i] );
          updatedArr.splice( i, 1 );
          i--;
        }
      }
    } );
    // this.getAdObjects( adObject );

    if ( this.ads && this.blacklist < 2 ) {
      this.getLog( ' GPT ', 'green' );
      this.getLog( ' GPT URL: ' + this.gptLibURL[this.ltdAdsEnabled] );
      const gads = document.createElement( 'script' );
      gads.async = true;
      gads.type = 'text/javascript';
      // gads.src = 'https://securepubads.g.doubleclick.net/tag/js/gpt.js';
      gads.src = this.gptLibURL[this.ltdAdsEnabled];
      const node = document.getElementsByTagName( 'script' )[0];
      node.parentNode.insertBefore( gads, node );

      // ID5 vs. GAM
      if (this.adObject.id5[0].id5Status === 1) {
        window.ID5EspConfig = { partnerId: this.adObject.id5[0].id5PartnerID };
      }

    }
  } // constructor

  uniqueArray( value, index, self ) {
    return self.indexOf(value) === index;
  }

  registerPlugins( plugins ) {
    const registered = {};
    plugins.forEach( ( plugin ) => {
      registered[plugin.name] = plugin.cb.bind( this );
    } );
    return registered;
  }

  eventify( arr, callback ) {
    if ( typeof arr === 'object' ) {
      arr.push = function( e ) {
        Array.prototype.push.call( arr, e );
        callback( arr );
      };
    }
  }

  getAdTest() {
    const searchParams = new URLSearchParams( window.location.search );
    if ( searchParams.has( 'adTest' ) ) {
      const adTest = searchParams.get( 'adTest' );
      this.myAdKeywords.push( adTest );
    }
    return;
  }

  getBlacklist( uri, adObject ) {
    let blacklist = 0;
    let bList = adObject.blacklistUrls;
    if ( Object.prototype.hasOwnProperty.call(bList, uri ) ) {
      blacklist = bList[uri];
      if ( blacklist === 1 ) {
        this.myAdKeywords.push( 'no_google' );
      }
    }
    return blacklist;
  }

  getScript(scriptName, scriptURL, scriptMode) {
    this.loadScript[scriptName] = document.createElement( 'script' );
    this.loadScript[scriptName].async = scriptMode;
    this.loadScript[scriptName].type = 'text/javascript';
    this.loadScript[scriptName].src = scriptURL;
    let scirptNode = document.getElementsByTagName( 'script' )[0];
    scirptNode.parentNode.insertBefore( this.loadScript[scriptName], scirptNode );
    this.getLog( ' getScript: ' + scriptName + ' : ' + scriptURL, 'green' );
  }

  debugMode( val ) {
    let debugValue = 'error';
    if ( val === 2 ) {
      window.sessionStorage.setItem( 'adLibDebugMode', 2 );
      if ( this.integration ) {
        window.pbjs.setConfig( {debugging: { enabled: true } } );
      }
      debugValue = val;
    }
    if ( val === 1 ) {
      window.sessionStorage.setItem( 'adLibDebugMode', 1 );
      debugValue = val;
    }
    if ( val === 0 ) {
      window.sessionStorage.setItem( 'adLibDebugMode', 0 );
      if ( this.integration ) {
        window.pbjs.setConfig( {debugging: { enabled: false } } );
      }
      debugValue = val;
    }
    this.getLog( ' debugMode: ' + debugValue + ' ', 'blue' );
  }

  getLog( l, s ) {
    let adLibDebugMode = window.sessionStorage.getItem( 'adLibDebugMode' );
    if ( adLibDebugMode >= 1 ) {
      let styles = [];
      let globalStyles = 'color: #fff; padding:3px 3px 2px;border-radius: 3px;';
      styles.a9 =  [ 'background: #FFA624', globalStyles ].join(';');
      styles.prebid =  [ 'background: #3887C2', globalStyles ].join(';');
      styles.organge =  [ 'background: #D95B43', globalStyles ].join(';');
      styles.red =  [ 'background: #B31A38', globalStyles ].join(';');
      styles.blue = [ 'background: #26ADE4', globalStyles ].join(';');
      styles.darkblue = [ 'background: #013976', globalStyles ].join(';');
      styles.green = [ 'background: #8A9B0F', globalStyles ].join(';');
      styles.seagreen = [ 'background: #79BD9A', globalStyles ].join(';');
      styles.bluegrey = [ 'background: #99B2B7', globalStyles ].join(';');
      styles.grey = [ 'background: #556270', globalStyles ].join(';');
      styles.black = [ 'background: #000', globalStyles ].join(';');
      styles.lila = [ 'background: #550055', globalStyles ].join(';');
      if ( typeof( s ) !== 'undefined'  ) {
        console.log('%c' + l , styles[s] ); // eslint-disable-line
      } else {
        console.log( l ); // eslint-disable-line
      }
    }
    return;
  }


  getAdObjects( obj ) {
    const adUnitLength = obj.adUnitCodes.length > 0 ? obj.adUnitCodes.length : 0;
    for ( let i = 0; i < adUnitLength; i++ ) {
      const adUnitClassId = '#' + obj.adUnitCodes[i].classId;
      const adUnit = document.querySelector( adUnitClassId );
      if ( adUnit !== null ) {
        if ( obj.adUnitCodesLogic[0].status === 1 && ( adUnitClassId === '#superbanner' || adUnitClassId === '#Billboard' ) ) {
          this.getLog( ' wallpaper status = ' + obj.adUnitCodesLogic[0].status );
        } else {
          if ( adUnit.classList.contains( 'lazyload' ) ) {
            this.getLog( 'LazyLaod: ' + adUnitClassId );
          } else {
            this.getLog( ' getAdObjects adQueue ' + adUnitClassId + ' ', 'lila' );
          }
        }
      }
    }
  }

  adCall( obj ) {
    this.myAdKeywords = this.myAdKeywords.filter( this.uniqueArray );
    this.getLog( this.myAdKeywords );


    const adUnitCodes = this.adObject.adUnitCodes;
    const adUnitLength = adUnitCodes.length > 0 ? adUnitCodes.length : 0;

    const sizes = function( AdObject ) {
      const adUnitMapping = window.googletag.sizeMapping();
      for ( let i = 0; i < AdObject.breakingPoints.length; i++ ) {
        adUnitMapping.addSize( AdObject.breakingPoints[i][0], AdObject.breakingPoints[i][1] );
      }
      return adUnitMapping.build();
    };

    this.getLog( this.bidder.definedAdSlots );

    for ( let i = 0; i < adUnitLength; i++ ) {
      if ( obj.data.adSlot === adUnitCodes[i].classId ) {
        const myAdObject = adUnitCodes[i];

        this.getLog( 'define slot: ' + obj.data.adSlot );
        this.bidder.definedAdSlots.push( obj.data.adSlot );
        this.bidder.definedAdSlots = this.bidder.definedAdSlots.filter( this.uniqueArray );
        this.getLog( this.bidder.definedAdSlots );

        let expandAdSlot = adUnitCodes[i].expanded;
        let collapseAdSlot = undefined;
        if ( expandAdSlot ) {
          collapseAdSlot = true;
        }

        window.googletag.cmd.push( () => {
          const adUnit = this.adObject.publisherDfpAdUrl + '/' + this.adZone;

          this.adSlots[myAdObject.classId] = window.googletag.defineSlot( adUnit, myAdObject.sizes, myAdObject.classId )
            .addService( window.googletag.pubads() )
            .defineSizeMapping( sizes( myAdObject ) )
            .setCollapseEmptyDiv( expandAdSlot, collapseAdSlot )
            .setTargeting( 'placement', myAdObject.classId )
            .setTargeting( 'kw', [this.myAdKeywords] )
            .setTargeting( 'ad_provider', this.adObject.adProvider )
            .setTargeting( 'ad_domain', this.adObject.adDomain );

          window.googletag.pubads().disableInitialLoad();
          window.googletag.pubads().enableSingleRequest();
          window.googletag.enableServices();

        } );

        if ( !this.integration || !this.getAdSlot( myAdObject.classId ) ) {
          // wenn der AdSlot nicht im Header bidding ist und direkt ausgeführt werden soll
          window.googletag.cmd.push( () => {
            this.getLog( ' ### prepairing ' + myAdObject.classId + ' ### ', 'green');
            // window.googletag.pubads().setRequestNonPersonalizedAds( this.nonPersonalizedAds );
            if ( this.ltdAdsEnabled ) {
              window.googletag.pubads().setPrivacySettings( { limitedAds: this.ltdAdsEnabled } );
            }
            window.adlib.getLog( myAdObject.classId + ': limitedAds ' + this.ltdAdsEnabled + ' ', 'bluegrey' );
            this.adRefresh( myAdObject.classId );
            this.getAdEvent( myAdObject );

          } );
        }
      }
    }
  }

  getAdSlot( adSlotID ) {
    let that = this;
    let hbAdSlotsLength = that.bidder.biddingAdSlots.length;
    let adSlotStatus = false;
    for ( let j = 0; j < hbAdSlotsLength; j++ ) {
      if ( adSlotID === that.bidder.biddingAdSlots[j] ) {
        // that.getLog('getAdSlot: ' + adSlotID + ' = ' + that.bidder.biddingAdSlots[j] + ' ', 'seagreen');
        adSlotStatus = true;
      }
    }
    // that.getLog('adSlotStatus: ' + adSlotStatus + ' ', 'grey');
    return adSlotStatus;
  }

  getAdUnitCodes( obj ) {
    const adUnitCodes = this.adObject.adUnitCodes;
    const adUnitLength = adUnitCodes.length > 0 ? adUnitCodes.length : 0;
    let myAdUnit = [];
    for ( let i = 0; i < adUnitLength; i++ ) {
      if ( obj === adUnitCodes[i].classId ) {
        myAdUnit = adUnitCodes[i];
      }
    }
    return myAdUnit;
  }

  adRefresh( myAdSlot ) {
    if (window.googletag && window.googletag.apiReady && window.googletag.pubads && window.googletag.pubads().refresh ) {
      this.getLog( ' adRefresh => ' + myAdSlot + ' ', 'lila' );
      window.googletag.pubads().refresh( [ window.adlib.adSlots[myAdSlot] ] );
    }
  }

  getSlotStatus( slotId, state ) {
    this.getLog( slotId + ' - ' + state);
  }

  getAdEvent( myAdObject ) {
    this.getLog( 'Function adEvent: ' + myAdObject );
    window.googletag.cmd.push( () => {
      window.googletag.pubads().addEventListener( 'slotRenderEnded', event => {
        if ( !event.isEmpty ) {
          if ( event.slot.getSlotElementId() === myAdObject.classId ) {
            this.getLog( 'adEvent: ' + event.slot.getSlotElementId() );
            // adDeclaration check
            if ( myAdObject.adDeclaration ) {
              document.querySelector( '#' + myAdObject.classId ).classList.add( 'adDeclaration', 'adDecoration' );
            }
            this.getLog( event.slot.getSlotElementId() + ' | adW: ' + event.size[0] + ' | adH: ' + event.size[1] + ' | WP: ' + this.adObject.adUnitCodesLogic[0].status );
            // skyscraper event.size[0] === 161 oder 1
            if ( event.slot.getSlotElementId() === 'skyscraper' && ( event.size[0] === ( 161 ) || event.size[0] === ( 1 ) ) && this.adObject.adUnitCodesLogic[0].status === 1 ) {
              this.getLog( ' Wallpaper ', 'green' );
              this.getLog( event.size[0] );
            }
            if ( event.slot.getSlotElementId() === 'skyscraper' && ( event.size[0] === ( 120 ) || event.size[0] === ( 160 ) || event.size[0] === ( 300 ) ) && this.adObject.adUnitCodesLogic[0].status === 1 ) {
              this.getLog( ' adDomain: ' + this.adObject.adDomain );
              this.getLog( ' kein wallpaper ', 'grey' );
              this.getLog( event.size[0] );
              this.adObject.adUnitCodesLogic[0].status = 0;
              if ( this.adObject.adDomain === 'rezepte_utopia_de' ) {
                this.adQueue.push( {type: 'adCall', data: {adSlot: 'Billboard'}} );
              } else {
                this.getLog( ' adQueue Superbanner ', 'lila' );
                this.adQueue.push( {type: 'adCall', data: {adSlot: 'superbanner'}} );
              }
            }
          }
        } else {
          if ( event.slot.getSlotElementId() === 'skyscraper' && this.adObject.adUnitCodesLogic[0].status === 1 ) {
            this.getLog( ' kein wallpaper ', 'black' );
            this.getLog( ' adDomain: ' + this.adObject.adDomain );
            this.adObject.adUnitCodesLogic[0].status = 0;
            if (this.adObject.adDomain === 'oekotest_de') {
              window.whenAvailable( '#superbanner', () => this.adQueue.push( {
                type: 'adCall',
                data: {adSlot: 'superbanner'},
              } ) );
            } else if ( this.adObject.adDomain === 'utopia_de' || this.adObject.adDomain === 'rezepte_utopia_de' ) {
              this.adQueue.push( { type: 'adCall', data: {adSlot: 'Billboard'} } );
            } else {
              this.getLog( ' adQueue Superbanner ', 'lila' );
              this.adQueue.push( {type: 'adCall', data: {adSlot: 'superbanner'}} );
            }
          }
        }
      } );
    } );
  }

  impressiontracking( obj ) {
    append( 'body', '<img src="' + obj.data.impressiontracking + '" border="0" height="1" width="1" alt="">' );
  }

  hideAdSlot( adSlotID ) {
    const elems = document.querySelectorAll( adSlotID );
    elems.forEach( ( elem ) => {
      elem.style.display = 'none';
    } );
  }

  removeAdSlot( adSlotID ) {
    const elems = document.querySelectorAll( adSlotID );
    elems.forEach( ( elem ) => {
      elem.parentNode.removeChild( elem );
    } );
  }

  background( obj ) {
    if ( obj.data.background ) {
      const body = document.querySelector( 'body' );
      if ( obj.data.backgroundcolor.length === 7 ) {
        body.style.backgroundColor = obj.data.backgroundcolor;
      }
      if ( obj.data.backgroundimage.length > 1 ) {
        body.style.backgroundImage = 'url(' + obj.data.backgroundimage + ')';
        body.style.backgroundSize = obj.data.backgroundsize;
        body.style.backgroundAttachment = obj.data.backgroundattachment;
      }
    }
  }

  skyscraperpositionfixed( obj ) {
    const elems = document.querySelectorAll( '#skyscraper_new, #left_skyscraper_new' );
    elems.forEach( ( elem ) => {
      elem.style.position = obj.data.skyscraperposition;
    } );

    function calcWpSpace() {
      let bb = document.getElementsByClassName('superbanner');
      let sky = document.getElementById('skyscraper_new');
      let rect = bb[0].getBoundingClientRect();
      let t = '' + rect.top + 'px';
      if ( rect.top < 0 ) { t = '60px'; }
      if ( obj.data.ad === 'fireplace' ) {
        let leftsky = document.getElementById('left_skyscraper_new');
        if ( leftsky !== 'undefined' ) {
          leftsky.style.setProperty('top', t);
        }
      }
      sky.style.setProperty('top', t);
    }
    setInterval(function() { calcWpSpace(); }, 500);
  }

  skyscraperpositionabsolute( obj ) {
    const elems = document.querySelectorAll( '#skyscraper_new, #left_skyscraper_new' );
    elems.forEach( ( elem ) => {
      elem.style.position = obj.data.skyscraperposition;
      elem.style.top = Number( obj.data.skyscraperpositiontop ) + 'px';
    } );
  }

  wallpaper( obj ) {
    this.getLog( obj );
    if ( this.skyscraper_1200 === 1 ) {
      // this.removeAdSlot( '#superbanner' );
      // this.removeAdSlot( '#Billboard' );

      const slotHead = document.querySelector( '.slot-head' );
      if ( slotHead !== null) {
        // this.getLog( '.slot-head gefunden');
        // this.getLog( slotHead);
        slotHead.style.paddingLeft = '0px';
        slotHead.style.paddingRight = '0px';
      } else {
        this.getLog( '.slot-head nicht gefunden');
      }

      const main = document.querySelector( 'main' );
      if ( main !== null) {
        // this.getLog( 'main gefunden');
        main.style.clear = 'both';
      }

      const content1 = document.querySelector( '#Content_1' );
      if ( content1 !== null) {
        content1.style.maxWidth = '1000px';
        content1.style.marginLeft = 'auto';
        content1.style.marginRight = 'auto';
      }
      const content2 = document.querySelector( '#Content_2' );
      if ( content2 !== null) {
        content2.style.maxWidth = '1000px';
        content2.style.marginLeft = 'auto';
        content2.style.marginRight = 'auto';
      }

      const superbannerposition = 1000 - Number( obj.data.superbannerwidth ) + Number( obj.data.superbannermarginleft );
      if ( obj.data.integration === 'image' ) {
        if ( obj.data.superbannerimg.length > 0 ) {
          insertBefore( '#Billboard', '<div class="superbanner" id="superbanner_new" style="float: left; z-index:19; width: ' + obj.data.superbannerwidth + 'px; height: ' + obj.data.superbannerheight + 'px; margin-left:' + superbannerposition + 'px"><a href="' + obj.data.klickziel + '" target="_blank"><img src="' + obj.data.superbannerimg + '" width="' + obj.data.superbannerwidth + '" height="' + obj.data.superbannerheight + '" alt="Banner"></a></div>' );
        }
        if ( obj.data.skyscraperimg.length > 0 ) {
          insertBefore( '#Billboard', '<div class="skyscraper" id="skyscraper_new" style="position: absolute; margin-left: 1000px; z-index:19; width: ' + obj.data.skyscraperwidth + 'px ; height: ' + obj.data.skyscraperheight + 'px;"><a href="' + obj.data.klickziel + '" target="_blank"><img src="' + obj.data.skyscraperimg + '" width="' + obj.data.skyscraperwidth + '" height="' + obj.data.skyscraperheight + '" alt="Banner"></a></div>' );
        }
        if ( obj.data.ad === 'fireplace' && obj.data.left_skyscraperimg.length > 0 ) {
          insertBefore( '#Billboard', '<div class="left_skyscraper" id="left_skyscraper_new" style="position: absolute; z-index:19; width: ' + obj.data.skyscraperwidth + 'px ; height: ' + obj.data.skyscraperheight + 'px; margin-left: -' + obj.data.skyscraperwidth + 'px"><a href="' + obj.data.klickziel + '" target="_blank"><img src="' + obj.data.left_skyscraperimg + '" width="' + obj.data.left_skyscraperwidth + '" height="' + obj.data.left_skyscraperheight + '" alt="Banner"></a></div>' );
        }
      } else if ( obj.data.integration === 'iframe' ) {
        if ( obj.data.superbanneriframe.length > 0 ) {
          insertBefore( '#Billboard', '<div class="superbanner" id="superbanner_new" style="float: left; z-index:19; width: ' + obj.data.superbannerwidth + 'px; height: ' + obj.data.superbannerheight + 'px; margin-left:' + superbannerposition + 'px"><iframe src="' + obj.data.superbanneriframe + '" width="' + obj.data.superbannerwidth + '" height="' + obj.data.superbannerheight + '" scrolling="no"></iframe></div>' );
        }
        if ( obj.data.skyscraperiframe.length > 0 ) {
          insertBefore( '#Billboard', '<div class="skyscraper" id="skyscraper_new" style="position: absolute; margin-left:1000px; z-index:19;"><iframe src="' + obj.data.skyscraperiframe + '" width="' + obj.data.skyscraperwidth + '" height="' + obj.data.skyscraperheight + '" scrolling="no"></iframe></div>' );
        }
        if ( obj.data.ad === 'fireplace' && obj.data.left_skyscraperiframe.length > 0 ) {
          insertBefore( '#Billboard', '<div class="left_skyscraper" id="left_skyscraper_new" style="position: absolute; z-index:19; width: ' + obj.data.left_skyscraperwidth + 'px ; height: ' + obj.data.left_skyscraperheight + 'px; margin-left: -' + obj.data.left_skyscraperwidth + 'px"><iframe src="' + obj.data.left_skyscraperiframe + '" width="' + obj.data.left_skyscraperwidth + '" height="' + obj.data.left_skyscraperheight + '" scrolling="no"></iframe></div>' );
        }
      }

      this.hideAdSlot( '#wpskyscraper' );
      if ( obj.data.impressiontracking.length > 0 ) {
        this.impressiontracking( obj );
      }
      if ( obj.data.background ) {
        this.background( obj );
      }
      if ( obj.data.skyscraperposition === 'fixed' ) {
        this.skyscraperpositionfixed( obj );
      }
      if ( obj.data.skyscraperposition === 'absolute' ) {
        this.skyscraperpositionabsolute( obj );
      }
    }
  }

  contentFeed( obj ) {
    this.getLog( ' recommendation_feed ' + obj.data.feed, 'blue' );
    this.getLog( obj );
    // this.getLog( obj );
    if ( obj.data.feed === 'taboola_video' || obj.data.feed === 'taboola' ) {
      append( '#recommendation_feed', '<div class="content_empfehlung_head">' + obj.data.headline + '</div><div id="' + obj.data.container + '" class="content_empfehlungen"></div>' );
      /* eslint-disable */
      window._taboola = window._taboola || [];
      _taboola.push( { article:'auto' } );
      !function(e, f, u, i) {
        if (!document.getElementById( i )){
          e.async = 1;
          e.src = u;
          e.id = i;
          f.parentNode.insertBefore( e, f );
        }
      }( document.createElement('script'),
        document.getElementsByTagName('script')[0],
        obj.data.network_string,
        'tb_loader_script' );
      if (window.performance && typeof window.performance.mark == 'function') {
        window.performance.mark('tbl_ic');
      }
      _taboola.push( {
        mode: obj.data.mode, // 'alternating-thumbnails-a',
        container: obj.data.container, // 'taboola-below-article-thumbnails',
        placement: obj.data.placement, // 'Below Article Thumbnails',
        target_type: obj.data.target_type, // 'mix'
      } );
      _taboola.push( { flush: true } );
      /* eslint-enable */
    }
    if ( obj.data.feed === 'outbrain' ) {
      let outbrainURI = document.querySelector( "link[rel='canonical']" ).href;
      this.getLog( ' recommendation_feed outbrain ', 'green' );
      append( '#recommendation_feed', '<div class="OUTBRAIN" data-src="' + outbrainURI + '" data-widget-id="' + obj.data.container + '"></div>' );
      this.getScript('outbrain', 'https://widgets.outbrain.com/outbrain.js', true);
    }
    if ( obj.data.impressiontracking.length > 0 ) {
      this.impressiontracking( obj );
    }
  }

  adLogic( obj ) {
    if ( obj.type === 'adData' ) {
      if ( obj.data.ad === 'wallpaper' || obj.data.ad === 'fireplace' ) {
        return this.wallpaper( obj );
      }
      if ( obj.data.ad === 'contentFeed' ) {
        return this.contentFeed( obj );
      }
    }
    if ( obj.type === 'adCall' ) {
      // let slot = obj.data.adSlot;
      let slot = 'off';
      let adAction = '';
      if ( Object.prototype.hasOwnProperty.call( this.adSlots, slot ) ) {
        this.getLog( 'REFRESH AdSlot: ' + slot );
        adAction = this.adRefresh( slot );
      } else {
        this.getLog( 'adCall: ' + obj.data.adSlot );
        adAction = this.adCall( obj );
      }
      return adAction;
    }
    if ( obj.type === 'fake' ) {
      return null;
    }
    return null;
  }

}
